export default __webpack_public_path__ + "static/media/indicator-sect4-before.fa38d3fc.svg";